import React, { useState } from "react";

import { useAppDispatch } from "../../../../../src/app/hooks";
import StageWorkflowDecisionModal from "../../../../../src/features/stageWorkflow/components/StageWorkflowDecisionModal";

import { AddStageRequest, CaseStageAction, CaseStageEnum } from "../../../../../src/api/caseStages";
import { useParams } from "react-router-dom";
import { showErrorToast, showSuccessToast } from "../../../../../src/lib/toast";
import { updateCaseStage } from "../../logic/thunks";
import { RejectButton } from "../../../../../src/components/ui/button/v2/RejectButton";

export const RejectCreatedCase: React.FC<{
  next_stage: CaseStageEnum
}> = ({next_stage})=> {
  const { id: caseId } = useParams<{ id: string }>();
  const dispatch = useAppDispatch();

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleOpen = (): void => {
    setIsModalOpen(true);
  };

  const handleClose = (): void => {
    if (isLoading) return;
    setIsModalOpen(false);
  };

  const handleReject = async () => {
  if (!caseId) {
    return;
  }

  try {
    setIsLoading(true);

    const request: AddStageRequest = {
      stage: next_stage,
      source_action: CaseStageAction.REJECT_CREATED_CASE,
    };

    await dispatch(
      updateCaseStage({
        caseId,
        request,
      })
    ).unwrap();

    showSuccessToast("Case rejected successfully");

    setIsModalOpen(false);
  } catch (error) {
    showErrorToast("Failed to reject case");
  } finally {
    setIsLoading(false);
  }
};

  return (
    <>
      <RejectButton
        label="Reject"
        onClick={handleOpen}
      />

      <StageWorkflowDecisionModal
        isOpen={isModalOpen}
        variant="reject"
        title="Reject Case Review"
        subtitle="Are you sure you want to reject this case?"
        primaryButtonLabel="Reject"
        onPrimaryAction={handleReject}
        onClose={handleClose}
        primaryDisabled={isLoading}
        primaryLoading={isLoading}
      />
    </>
  );
};
